module.exports = __webpack_public_path__ + "static/media/2019-03-14-02.67834a4b.jpg";